import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { disconnectNylas, getMailInfo, updateBillingAccess } from '../../profile/core/_requests'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { toast } from 'react-toastify'
import { useAuth } from '../../auth'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import TagManager from 'react-gtm-module'
import { removeNullFields } from '../../../core/_util'
import { useThemeMode } from '../../../../_metronic/partials'
import warningIcon from '../../../../media/billing/ic-warning.svg'
import TickMark from '../../../../media/billing/ic-tickmark.svg'
import { comparision, plansRK } from '../core/_constants'
import React from 'react'
import brandingConfig from '../../../../config/brandingConfig'

export const BillingModal = ({
  modalShow,
  setModalShow,
  currentState,
  setCurrentState,
  selected,
  setSelected,
  currencyBill,
  // plans,
  setPrice,
  upgrade,
  companyId,
  getBillingDetails,
  onAccessBillingPortal,
}: {
  modalShow: boolean
  setModalShow: Dispatch<SetStateAction<boolean>>
  currentState: string
  setCurrentState?: Dispatch<SetStateAction<string>>
  selected: string
  setSelected?: Dispatch<SetStateAction<string>>
  currencyBill: string
  setPrice?: Dispatch<SetStateAction<string>>
  upgrade: boolean
  getBillingDetails?: () => Promise<void>
  // plans: {
  //   title: string
  //   curreny: string
  //   priceMonthINR: string
  //   priceAnnualINR: string
  //   priceMonthUSD: string
  //   priceAnnualUSD: string
  //   custom: boolean
  //   label?: string
  //   features: {title: string; supported: boolean}[]
  // }[]
  companyId?: number | undefined
  onAccessBillingPortal?: () => Promise<void>
}) => {
  const [localBilling, setlocalBilling] = useState<string>('Monthly')
  const [localPlan, setlocalPlan] = useState<any | undefined>('Basic')
  const [localPrice, setlocalPrice] = useState('0')
  const [loading, setLoading] = useState(false)
  const { formatMessage } = useIntl()
  const { setBillingData, setEntitlements, billingData } = useAuth()
  const { mode } = useThemeMode()
  const recommended = 'Gold'

  const onUpgradePlan = async (plan: string) => {
    try {
      if (upgrade) {
        setLoading(true)
        if (companyId) {
          const currency = billingData?.company_country?.currency === 'INR' ? 'USD' : 'USD'
          const chargebeePlanId = `${plan}-${currency}-${localBilling}`
          const {
            data: { success, errors },
          } = await updateBillingAccess(companyId, chargebeePlanId)
          if (success) {
            setLoading(false)
            setModalShow(false)
            toast.success(formatMessage({ id: 'Successful Update Plan' }))
            const result: any = await getBillingDetails!()
            setBillingData({
              ...result.output,
              ...result.customer_info,
              renewal_estimate: result.renewal_estimate,
              transaction_id: result.current_plan_invoice_id,
              company_country: result.company_country,
            })
            if (result?.output?.subscription_items[0].item_price_id.split('-')[0] === 'Basic') {
              getMailInformation()
            }
            setEntitlements(result.entitlement_list)
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CompanyPlanChangedSuccessful,
                metadata: removeNullFields({
                  old_plan: selected,
                  new_plan: chargebeePlanId,
                  new_plan_amount: localPrice,
                  currency: billingData?.company_country?.currency === 'INR' ? 'USD' : 'USD',
                }),
              },
            })
          } else {
            setLoading(false)
            setModalShow(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({ id: error }))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CompanyPlanChangedFailed,
                metadata: removeNullFields({
                  old_plan: selected,
                  new_plan: chargebeePlanId,
                  new_plan_amount: localPrice,
                  currency: billingData?.company_country?.currency === 'INR' ? 'USD' : 'USD',
                }),
              },
            })

            if (errors.includes('Please add a payment method from the billing portal.')) {
              /* Do not open access portal anymore
              if (onAccessBillingPortal) {
                const portalSession: any = await onAccessBillingPortal!()
                setBillingPortalUrl(portalSession.access_url)
                setShowBillingModal(false)
                setShowBillingAccessModal(true)
              } */
            }
          }
        }
      }
      if (setCurrentState && setSelected && setPrice) {
        setCurrentState(localBilling)
        setSelected(localPlan)
        setPrice(localPrice)
        setModalShow(false)
      }
    } catch (err) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CompanyPlanChangedFailed,
          metadata: removeNullFields({
            old_plan: selected,
            new_plan: localPlan,
            new_plan_amount: localPrice,
            currency: billingData?.company_country?.currency === 'INR' ? 'USD' : 'USD',
          }),
        },
      })
      setLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    setlocalBilling(currentState)
    setlocalPlan(selected)
  }, [currentState, selected, modalShow])

  useEffect(() => {
    if (modalShow) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.PaywallShownSuccessful,
          metadata: {},
        },
      })
    }
  }, [modalShow])

  const handleConfirmDisconnect = async () => {
    try {
      const isNylasActive = 'disconnect'
      const {
        data: { data, success, errors }, // eslint-disable-line
      } = await disconnectNylas(isNylasActive, companyId)
      if (success) {
        console.log('Downgraded')
      } else {
        toast.error(errors[0])
      }
    } catch (error) {
      toast.error(formatMessage({ id: 'Something went wrong while disconnecting your account.' }))
    } finally {
    }
  }
  const getMailInformation = async () => {
    try {
      const {
        data: { success, data, errors },
      } = await getMailInfo(companyId)
      if (success) {
        if (data.nylasGoogle || data.nylasMicrosoft) {
          handleConfirmDisconnect()
        }
      } else {
        console.log(errors)
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  // const plansRK = [
  //   {
  //     title: 'Basic',
  //     subheader: 'Perfect for solo professionals/personal use',
  //     curreny: 'INR',
  //     priceMonthINR: 'Free Forever',
  //     priceAnnualUSD: 'Free Forever',
  //     priceMonthUSD: 'Free Forever',
  //     priceAnnualINR: 'Free Forever',
  //     custom: false,
  //     features: [
  //       {
  //         title: '100 MB Storage',
  //       },
  //       {
  //         title: '500 AI Search and Retrievals',
  //       },
  //       {
  //         title: '100 File Processing',
  //       },
  //       {
  //         title: '1 Team Member',
  //       },
  //       {
  //         title: 'Company Page',
  //       },
  //       {
  //         title: 'Support',
  //       },
  //       {
  //         title: 'Training Hub',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'Silver',
  //     subheader: 'Ideal for small teams & growing businesses',
  //     curreny: 'INR',
  //     priceMonthINR: '7,999.00',
  //     priceAnnualINR: '79,990.00',
  //     priceMonthUSD: '99.00',
  //     priceAnnualUSD: '990.00',
  //     custom: false,
  //     label: '',
  //     features: [
  //       {
  //         title: '1 GB Storage',
  //       },
  //       {
  //         title: '5000 AI Search and Retrievals',
  //       },
  //       {
  //         title: '1000 File Processing',
  //       },
  //       {
  //         title: '3 Team Member',
  //       },

  //       {
  //         title: 'Create 3 Data Rooms',
  //       },
  //       {
  //         title: 'Create 10 Compliance Meetings',
  //       },
  //       {
  //         title: 'Cap Table Management',
  //       },
  //       {
  //         title: '5 Documents Signing',
  //       },
  //       {
  //         title: 'Shared Inbox, Calendar, & Contacts',
  //       },
  //       {
  //         title: 'Bulk Import',
  //       },
  //       {
  //         title: 'Company Page',
  //       },
  //       {
  //         title: 'Support',
  //       },
  //       {
  //         title: 'Training Hub',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'Gold',
  //     subheader: 'Best for mid-sized organizations and startups',
  //     curreny: 'INR',
  //     priceMonthINR: '15,990.00',
  //     priceAnnualINR: '1,59,900.00',
  //     priceMonthUSD: '199.00',
  //     priceAnnualUSD: '1,990.00',
  //     custom: false,
  //     label: 'Popular',
  //     features: [
  //       {
  //         title: '10 GB Storage',
  //       },
  //       {
  //         title: '10,000 AI Search and Retrievals',
  //       },
  //       {
  //         title: '50,000 File Processing',
  //       },
  //       {
  //         title: '10 Team Members',
  //       },

  //       {
  //         title: 'Create 10 Data Rooms',
  //       },
  //       {
  //         title: 'Create 25 Compliance Meetings',
  //       },
  //       {
  //         title: 'Cap Table Management',
  //       },
  //       {
  //         title: '20 Documents Signing',
  //       },
  //       {
  //         title: 'Shared Inbox, Calendar, & Contacts',
  //       },
  //       {
  //         title: 'Bulk Import',
  //       },
  //       {
  //         title: 'Company Page',
  //       },
  //       {
  //         title: 'Support',
  //       },
  //       {
  //         title: 'Training Hub',
  //       },
  //       {
  //         title: 'Data Export',
  //       },
  //     ],
  //   },
  //   {
  //     title: 'Platinum',
  //     subheader: 'Complete solution for established enterprises',
  //     curreny: 'INR',
  //     priceMonthINR: '39,990.00',
  //     priceAnnualINR: '3,99,900.00',
  //     priceMonthUSD: '499.00',
  //     priceAnnualUSD: '4,990.00',
  //     custom: false,
  //     label: 'Recommended',
  //     features: [
  //       {
  //         title: '50,000 Storage',
  //       },
  //       {
  //         title: '50,000 AI Search and Retrievals',
  //       },
  //       {
  //         title: '500,000 File Processing',
  //       },
  //       {
  //         title: '20 Team Members',
  //       },

  //       {
  //         title: 'Create 50 Data Rooms',
  //       },
  //       {
  //         title: 'Create 60 Compliance Meetings',
  //       },
  //       {
  //         title: 'Cap Table Management',
  //       },
  //       {
  //         title: '100 Documents Signing',
  //       },
  //       {
  //         title: 'Shared Inbox, Calendar, & Contacts',
  //       },
  //       {
  //         title: 'Bulk Import',
  //       },
  //       {
  //         title: 'Company Page',
  //       },
  //       {
  //         title: 'Support',
  //       },
  //       {
  //         title: 'Training Hub',
  //       },
  //       {
  //         title: 'Data Export',
  //       },
  //     ],
  //   },
  // ]
  // const comparision = {
  //   plans: [
  //     {
  //       title: 'Basic',
  //       subheader: 'Best for individuals',
  //     },
  //     {
  //       title: 'Silver',
  //       subheader: 'Best for small teams',
  //     },
  //     {
  //       title: 'Gold',
  //       subheader: 'Best for startups',
  //     },
  //     {
  //       title: 'Platinum',
  //       subheader: 'Best for corporations',
  //     },
  //     {
  //       title: 'Enterprise',
  //       subheader: 'Built for custom needs',
  //     },
  //   ],
  //   details: [
  //     {
  //       availability: ['RecordsKeeper.AI', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'RecordsKeeper.AI Storage Limit',
  //           limits: ['100MB', '1GB', '10GB', '50GB', 'Custom'],
  //         },
  //         {
  //           title: 'File Processing',
  //           limits: ['100', '1,000', '10,000', '50,000', 'Custom'],
  //         },
  //         {
  //           title: 'AI Search and Retrieval',
  //           limits: ['500', '5,000', '50,000', '50,0000', 'Custom'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Stakeholders Management', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Stakeholders Limit',
  //           limits: ['5', '25', '60', '100', 'Custom'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Data Rooms', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Number of Data Rooms',
  //           limits: ['0', '3', '10', '50', 'Custom'],
  //         },
  //         {
  //           title: 'Data Rooms Storage Limit',
  //           limits: ['0', '500MB', '2GB', '10GB', 'Custom'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Compliance Meetings Management', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Number of Board Meetings',
  //           limits: ['0', '10', '25', '60', 'Custom'],
  //         },
  //         {
  //           title: 'Access to Shareholders Meeting Management',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Number of Shareholders Meetings',
  //           limits: ['0', '5', '15', '30', 'Custom'],
  //         },
  //         {
  //           title: 'Automatic Minutes of Meeting Generation',
  //           limits: ['No', 'No', 'Yes', 'Yes', 'Yes'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Cap Table Management', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Captable Projections',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Historic Captable',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Captable Simulation',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Digital Signing', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Documents Limit',
  //           limits: ['0', '5', '25', '100', 'Custom'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Shared Access', 'No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Email Integration',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Shared Email Inbox',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Shared Calendar',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Automatic Meeting Links',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Shared Contacts',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'AI Helper for Communication',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Training Hub', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //     },
  //     {
  //       availability: ['Others', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Data Export',
  //           limits: ['No', 'No', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Bulk Import',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Team Members',
  //           limits: ['1', '3', '10', '20', 'Custom'],
  //         },
  //       ],
  //     },
  //     {
  //       availability: ['Support', 'Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //       includes: [
  //         {
  //           title: 'Access to Help Center',
  //           limits: ['Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Email support',
  //           limits: ['Yes', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Chat Support',
  //           limits: ['No', 'Yes', 'Yes', 'Yes', 'Yes'],
  //         },
  //         {
  //           title: 'Video Call Support',
  //           limits: ['No', 'No', 'Yes', 'Yes', 'Yes'],
  //         },
  //       ],
  //     },
  //   ],
  // }

  return (
    <>
      <Modal
        fullscreen
        show={modalShow}
        onHide={() => {
          setlocalPlan(selected)
          setModalShow(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpgradeModalClosed,
              metadata: {
                company_id: companyId,
                page_url: `${window.location.origin}/${window.location.pathname}?tab=billing`,
              },
            },
          })
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <div className=' d-flex align-items-center fw-bold'>
            <h2 className='font-size-20'>{formatMessage({ id: 'Update to New Plan' })}</h2>
          </div>
        </Modal.Header>
        <Modal.Body className='container' style={{ overflowY: 'scroll', scrollbarWidth: 'none' }}>
          <div
            className={`alert mt-4 alert-warning d-flex p-4 gap-4`}
            style={{ color: '#383940', background: `${mode === 'dark' ? '#FFF8DD' : ''}` }}
          >
            <img src={warningIcon} alt='' />
            <div>
              <h1 className='font-size-16 fw-semibold text-black'>
                {formatMessage({ id: 'Upgrade Required to Unlock This Feature!' })}
              </h1>
              <p className='font-size-13 fw-medium m-0 text-black'>
                {formatMessage({
                  id: `Your current plan does not include access to this feature. Upgrade now to continue and unlock its full potential, or contact your account or billing administrator for assistance.`,
                })}
              </p>
            </div>
          </div>
          <div className='d-flex flex-md-row flex-column align-items-center justify-content-between py-4'>
            <h1 className='font-size-20 lh-base mb-4 mb-md-0'>
              {formatMessage({ id: 'Select a Subscription Plan to Continue' })}
            </h1>
            <div className='d-flex flex-md-row flex-column align-items-center gap-4'>
              <p className='text-primary mb-0'>
                <span className='fw-bold'>{formatMessage({ id: '2 Months Free' })}</span>
                {formatMessage({ id: ' with Yearly Billing!' })}
              </p>
              <div className='rounded-pill border border-2 d-flex bg-white cursor-pointer'>
                <p
                  className={`mb-0 py-4 px-6 rounded-pill ${localBilling === 'Yearly' ? 'bg-primary text-white ' : ''
                    }`}
                  style={{ transition: 'background-color 0.3s ease, color 0.3s ease' }}
                  onClick={() => {
                    // setlocalPlan(plansRK[0].title)
                    billingData?.company_country?.currency === 'INR'
                      ? setlocalPrice(plansRK[0]?.priceAnnualUSD)
                      : setlocalPrice(plansRK[0]?.priceAnnualUSD)
                    setlocalBilling('Yearly')
                  }}
                >
                  {formatMessage({ id: 'Yearly' })}
                </p>
                <p
                  className={`mb-0 py-4 px-6 rounded-pill ${localBilling === 'Monthly' ? 'bg-primary text-white ' : ''
                    }`}
                  style={{ transition: 'background-color 0.3s ease, color 0.3s ease' }}
                  onClick={() => {
                    // setlocalPlan(plansRK[0].title)
                    billingData?.company_country?.currency === 'INR'
                      ? setlocalPrice(plansRK[0]?.priceMonthUSD)
                      : setlocalPrice(plansRK[0]?.priceMonthUSD)
                    setlocalBilling('Monthly')
                  }}
                >
                  {formatMessage({ id: 'Monthly' })}
                </p>
              </div>
            </div>
          </div>
          <div className='d-flex flex-md-row flex-column gap-4 py-4'>
            {plansRK.map((plans: any) => (
              <>
                <div
                  className={`w-md-25 w-100 border border-2 rounded px-4 py-6 d-flex flex-column gap-2 position-relative ${plans.title === selected && currentState === localBilling
                    ? 'border-success'
                    : ''
                    }`}
                >
                  {plans.title === selected && currentState === localBilling && (
                    <div
                      className='position-absolute top-0 end-0 px-6 py-2 border border-2 border-top-0 border-end-0 border-success text-success bg-success bg-opacity-10'
                      style={{ borderBottomLeftRadius: '6px' }}
                    >
                      {formatMessage({ id: 'Current Plan' })}
                    </div>
                  )}
                  {plans.title === recommended && (
                    <div
                      className={`position-absolute top-0 end-0 px-6 py-2 text-primary bg-primary bg-opacity-10 ${selected === recommended && 'd-none'
                        }`}
                      style={{ borderBottomLeftRadius: '6px', borderTopRightRadius: '4.5px' }}
                    >
                      {formatMessage({ id: 'Recommended' })}
                    </div>
                  )}
                  <div>
                    <h1 className='font-size-20 lh-base mb-1'>
                      {formatMessage({ id: plans.title })}
                    </h1>
                    <p className='text-muted font-size-12 lh-base mb-0' style={{ minHeight: '36px' }}>
                      {formatMessage({ id: plans.subheader })}
                    </p>
                  </div>
                  <h1 className='d-flex align-items-end mb-0 py-6'>
                    <span className='d-flex font-size-16 mb-1'>
                      {plans.title !== 'Basic'
                        ? billingData?.company_country?.currency === 'INR'
                          ? '$'
                          : '$'
                        : ''}
                    </span>
                    {billingData?.company_country?.currency === 'INR' ? (
                      localBilling === 'Yearly' ? (
                        <p className='font-size-32 mb-0'>
                          {formatMessage({ id: plans.priceAnnualUSD })}
                          <span className='font-size-16'>{formatMessage({ id: '/Year' })}</span>
                        </p>
                      ) : (
                        <p className='font-size-32 mb-0'>
                          {formatMessage({ id: plans.priceMonthUSD })}
                          <span className='font-size-16'>{formatMessage({ id: '/Month' })}</span>
                        </p>
                      )
                    ) : localBilling === 'Monthly' ? (
                      <p className='font-size-32 mb-0'>
                        {formatMessage({ id: plans.priceMonthUSD })}
                        <span className='font-size-16'>{formatMessage({ id: '/Month' })}</span>
                      </p>
                    ) : (
                      <p className='font-size-32 mb-0'>
                        {formatMessage({ id: plans.priceAnnualUSD })}
                        <span className='font-size-16'>{formatMessage({ id: '/Year' })}</span>
                      </p>
                    )}
                  </h1>
                  <BasicButton
                    buttonText={formatMessage({ id: 'Buy plan' })}
                    border='none'
                    color='#4776E6'
                    textColor='#FFFFFF'
                    height='44'
                    padding='12px 24px'
                    minWidth={137}
                    onClick={() => {
                      setlocalPlan(plans.title)
                      onUpgradePlan(plans.title)
                    }}
                    loading={loading && plans.title === localPlan}
                    disabled={plans.title === selected && currentState === localBilling}
                  />

                  <p className='text-center mb-0 font-size-11 mt-2'>
                    {formatMessage({
                      id: `${brandingConfig.freeTrialDays}-day Free Trial. No Credit Card Needed.`,
                    })}
                  </p>
                  {plans.title === 'Personal' ? (
                    <p className='text-primary mb-0 bg-primary bg-opacity-10 border border-primary rounded text-center py-1 mt-4'>
                      {formatMessage({ id: 'Personal & Family Use Only' })}
                    </p>
                  ) : (
                    <p className='text-success mb-0 bg-success bg-opacity-10 border border-success rounded text-center py-1 mt-4'>
                      {formatMessage({ id: 'Business Use Only' })}
                    </p>
                  )}
                  <p className='font-size-14 mb-2 fw-semibold mt-4'>
                    {formatMessage({ id: `${plans.title} Plan Includes:` })}
                  </p>
                  {plans.features.map((feature: any, index: number) => (
                    <div key={index} className='d-flex align-items-center gap-3'>
                      <img src={TickMark} alt='tick mark' height={20} width={20} />
                      <p className='mb-0'>{formatMessage({ id: feature.title })}</p>
                    </div>
                  ))}
                </div>
              </>
            ))}
          </div>
          <div className='d-flex flex-md-row flex-column justify-content-between gap-4 py-4'>
            <div className='d-flex flex-column gap-2 w-md-25 w-100 p-4 border border-primary rounded'>
              <h1 className='font-size-20 mb-0'>
                {formatMessage({ id: 'Didn’t Find what you are looking for?' })}
              </h1>
              <button className='btn bg-primary custom-button-property text-white'>
                <a
                  className='text-white'
                  href='https://app.apollo.io/#/meet/kfz-9k8-lb3/recordskeeper-demo'
                >
                  {formatMessage({ id: 'Lets Connect' })}
                </a>
              </button>
            </div>
            <div
              className='d-flex flex-md-row flex-column gap-4 w-md-75 w-100 justify-content-between align-items-md-center align-items-start p-md-8 p-4 rounded'
              style={{ background: 'rgba(37, 57, 111, 1)' }}
            >
              <div className='d-flex flex-column'>
                <h1 className='mb-0 text-white text-start'>
                  {formatMessage({ id: 'Looking for an Enterprise Plan?' })}
                </h1>
                <p className='mb-0 text-white text-start'>
                  {formatMessage({ id: 'Unlimited Access to RecordsKeeper.AI' })}
                </p>
              </div>
              <button className='btn bg-success custom-button-property text-white w-100 w-md-auto'>
                <a
                  className='text-white'
                  href='https://app.apollo.io/#/meet/kfz-9k8-lb3/recordskeeper-demo'
                >
                  {formatMessage({ id: 'Talk to Sales' })}
                </a>
              </button>
            </div>
          </div>
          <div className='py-4'>
            <div className='accordion border border-2 rounded' id='accordionExample'>
              <div className='accordion-item'>
                <h2 className='accordion-header'>
                  <button
                    className='accordion-button font-size-14 fw-semibold lh-base'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#collapseOne'
                    aria-expanded='true'
                    aria-controls='collapseOne'
                  >
                    {formatMessage({ id: 'Detailed Subscription Plan Comparison' })}
                  </button>
                </h2>
                <div
                  id='collapseOne'
                  className='accordion-collapse collapse show'
                  data-bs-parent='#accordionExample'
                >
                  <div className='accordion-body'>
                    <div style={{ overflowX: 'auto' }}>
                      <table className='table'>
                        <thead>
                          <tr>
                            <td colSpan={2}></td>
                            {comparision.plans.map((plan, index) => {
                              return (
                                <td
                                  key={index}
                                  className={`text-center ${plan.title === selected ? 'rounded-top' : ''
                                    }`}
                                  style={{
                                    background:
                                      plan.title === selected
                                        ? mode === 'dark'
                                          ? '#0D0D16'
                                          : '#C7FFE2'
                                        : '',
                                  }}
                                >
                                  {plan.title === selected && (
                                    <h1
                                      className='font-size-14 fw-medium mb-0 text-success lh-base'
                                      style={{ background: mode === 'dark' ? '#0D0D16' : '#C7FFE2' }}
                                    >
                                      {formatMessage({ id: 'Active Plan' })}
                                    </h1>
                                  )}
                                </td>
                              )
                            })}
                          </tr>
                          <tr>
                            <td colSpan={2}></td>
                            {comparision.plans.map((plan, index) => {
                              return (
                                <td key={index} className='px-0 py-0'>
                                  <div
                                    className='mb-0 pt-4 pb-8 text-center'
                                    style={{
                                      background:
                                        plan.title === selected
                                          ? mode === 'dark'
                                            ? '#161621'
                                            : '#E8FFF3'
                                          : '',
                                    }}
                                  >
                                    <h1 className='font-size-16 lh-base'>
                                      {formatMessage({ id: plan.title })}
                                    </h1>
                                    <span className='text-muted'>
                                      {formatMessage({ id: plan.subheader })}
                                    </span>
                                  </div>
                                </td>
                              )
                            })}
                          </tr>
                        </thead>
                        <tbody className='pb-4'>
                          {comparision.details.map((detail, index) => (
                            <React.Fragment key={index}>
                              <tr>
                                {detail.availability.map((data, availabilityIndex) => (
                                  <td
                                    key={availabilityIndex}
                                    colSpan={availabilityIndex === 0 ? 2 : 1}
                                    className='px-0 py-0'
                                  >
                                    <p
                                      className={`mb-0 py-4 bg-primary bg-opacity-25 fw-bold
                                                  ${availabilityIndex === 0
                                          ? 'text-start rounded-start ps-4'
                                          : 'text-center'
                                        } 
                                                  ${availabilityIndex === detail.availability.length - 1
                                          ? 'rounded-end'
                                          : ''
                                        }
                                                `}
                                      style={{
                                        background:
                                          availabilityIndex > 0 &&
                                            comparision.plans[availabilityIndex - 1].title ===
                                            selected
                                            ? mode === 'dark'
                                              ? '#161621'
                                              : '#E8FFF3'
                                            : '',
                                      }}
                                    >
                                      {formatMessage({ id: data })}
                                    </p>
                                  </td>
                                ))}
                              </tr>
                              {detail?.includes?.map((item, includeIndex) => (
                                <tr key={includeIndex} className='border-bottom'>
                                  <td colSpan={2} className='px-4 py-0' style={{ minWidth: '320px' }}>
                                    <p className='mb-0 py-4'>{item.title}</p>
                                  </td>

                                  {item?.limits?.map((limit, limitIndex) => (
                                    <td
                                      key={limitIndex}
                                      className='px-0 py-0 bg-transparent'
                                      style={{ minWidth: '150px' }}
                                    >
                                      <p
                                        className='mb-0 py-4 text-center'
                                        style={{
                                          background:
                                            limitIndex >= 0 &&
                                              comparision.plans[limitIndex].title === selected
                                              ? mode === 'dark'
                                                ? '#161621'
                                                : '#E8FFF3'
                                              : '',
                                        }}
                                      >
                                        {formatMessage({ id: limit })}
                                      </p>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                              <tr>
                                <td className='px-0 py-0' colSpan={2}></td>
                                {comparision.plans.map((plan, planIndex) => (
                                  <td key={planIndex} className='px-0 py-0 rounded-bottom'>
                                    {plan.title === selected && (
                                      <div
                                        className={`mb-0 py-2 
                                                   ${index === comparision.details.length - 1
                                            ? 'rounded-bottom'
                                            : 'border-bottom-0'
                                          }`}
                                        style={{
                                          background:
                                            plan.title === selected
                                              ? mode === 'dark'
                                                ? '#161621'
                                                : '#E8FFF3'
                                              : '',
                                        }}
                                      />
                                    )}
                                  </td>
                                ))}
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
